import { Create } from "react-admin";
import ComponentEdit from "../../../components/PageComponents/ComponentEdit";
import ProjectForm from "./ProjectForm";

const ProjectCreate = () => (
  <ComponentEdit title="New entity" subtitle="Create an entity and choose how it accepts payments.">
    <Create redirect="show" actions={false} sx={{ "& .RaCreate-card": { overflow: "visible" } }}>
      <ProjectForm create />
    </Create>
  </ComponentEdit>
);

export default ProjectCreate;
